// extracted by mini-css-extract-plugin
module.exports = {"bodyText":"_3CPWvzw","h5Text":"_2tvW0eQ","h4Text":"_3hSTuD-","h3Text":"_1_oKB1_","srOnly":"_2fZ_CBc","link":"_3i_lZfj _3CPWvzw","USSalesTax":"DpUWsSt"};